export enum LoginRestrictionTypeEnum {
    MAX_COUNT = 'MAX_COUNT',
    IP_ADDRESS = 'IP_ADDRESS',
}
